var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.49,
    y: 4.31,
    width: 13.02,
    height: 1.45,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.49,
    y: 8.27,
    width: 13.02,
    height: 1.45,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.49,
    y: 12.23,
    width: 13.02,
    height: 1.45,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.04,0H3.96C1.78,0,0,1.78,0,3.96v10.07c0,2.19,1.78,3.96,3.96,3.96h14.07c2.19,0,3.96-1.78,3.96-3.96V3.96c0-2.19-1.78-3.96-3.96-3.96ZM20.55,14.04c0,1.38-1.13,2.51-2.51,2.51H3.96c-1.38,0-2.51-1.13-2.51-2.51V3.96c0-1.38,1.13-2.51,2.51-2.51h14.07c1.38,0,2.51,1.13,2.51,2.51v10.07Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.3791608d31beabb570dd674fed67581e.svg";
export { ForwardRef as ReactComponent };